import { render } from "./CheckoutSecondaryTitle.vue?vue&type=template&id=3934b39f"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3934b39f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3934b39f', script)) {
    api.reload('3934b39f', script)
  }
  
  module.hot.accept("./CheckoutSecondaryTitle.vue?vue&type=template&id=3934b39f", () => {
    api.rerender('3934b39f', render)
  })

}

script.__file = "src/views/payments/modules/pageTitles/CheckoutSecondaryTitle.vue"

export default script